import React from 'react'
import PL9BeerMenuBoard from './PL9BeerMenuBoard'
import PL5BeerMenuBoard from './PL5BeerMenuBoard'

const BeerMenuBoardRouter = (props) => {
    console.log(props)
    let location = props.location
    let layout = props.layout

    if (location === "pl9"){
        return (
            <PL9BeerMenuBoard 
                tapMenu={props.tapMenu}
                canMenu={props.canMenu}
                filterStyle={props.filterStyle}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                refactorAbv={props.refactorAbv}
                location={props.location}
                layout={props.layout}

            />
        )
    } else if (location === "pl5"){
        return (
            <PL5BeerMenuBoard 
                tapMenu={props.tapMenu}
                canMenu={props.canMenu}
                filterStyle={props.filterStyle}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                refactorAbv={props.refactorAbv}
                location={props.location}
                layout={props.layout}
            />
        )
    } else {
        return (
            <div>loading...</div>
        )
    }
}
export default BeerMenuBoardRouter